import React, { useEffect, useState } from "react";
import {
  logo,
  aboveHeader2,
  aboveHeader3,
  aboveHeader4,
  aboveHeader1,
} from "../../assets/images";
import axios from "axios";
import PaginatedItems from "./PaginatedItems";
import PaginatedItemsMobile from "./PaginatedItemsMobile";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../LanguageSwitcher";
import { useDispatch, useSelector } from "react-redux";
import { clearFavourites } from "../redux/favouritesSlice";
import { clearCart } from "../redux/cartItemsSlice";
import { clearLocations } from "../redux/locationsSlice";
import { clearComments } from "../redux/commentsSlice";
import { clearUser } from "../redux/userSlice";

const Header = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state.user); // userSlice'tan
    const cartItems = useSelector((state) => state.cartItems.items);
  const isLoggedIn = user.isLoggedIn;
  const isLoggedInUser = user.name; 

  const logoutSubmit = () => {
    // ✅ Redux'ı temizle
    dispatch(clearFavourites());
    dispatch(clearCart());
    dispatch(clearLocations());
    dispatch(clearComments());
    dispatch(clearUser()); // ✅ Kullanıcı bilgisini sıfırla

    navigate("/");
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);

  const toggleSearch = () => {
    setSearchQuery("");
  };

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );
      setProducts(response.data.data);
      setIsLoading2(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const isActiveLink = (path) => location.pathname === path;

  const filteredProducts = searchQuery
    ? products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const toggleHamburgerMenu = () => {
    setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
    setSearchQuery("");
  };

  return (
    <>
      <div className="border-b-[1px] border-[#EBEBEB] bg-white">
        <div className="hidden md:flex md:max-w-container h-[80px] justify-between items-center relative mx-auto">
          <div className="flex items-center">
            <a href={`/${currentLanguage}`}>
              {" "}
              <img className="w-[48px] h-[48px]" alt="Logo" src={logo}></img>
            </a>
          </div>
          <div className="w-[600px] justify-center hidden md:flex">
            <div className="relative">
              <button className="absolute top-3 left-4 text-white">
                <img alt="Search" className="h-6 w-6" src={aboveHeader1}></img>
              </button>
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder={t("Axtar...")}
                className="rounded-[8px] w-[600px] bg-[#F5F5F5] h-[44px] outline-none focus:ring-0 focus:outline-none px-12 text-firstColor"
              />
              <button
                onClick={toggleSearch}
                className="absolute top-[11px] right-4 text-white"
              ></button>
            </div>
          </div>
          <div className="flex gap-10">
            <div className="flex gap-3 items-center">
              <div className="relative inline-block text-left">
                {isLoggedIn ? (
                  <div>
                    <button
                      type="button"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      className="bg-[#181D27] text-white px-6 sm:px-7 md:px-8 py-2 rounded-full"
                    >
                      {isLoggedInUser || t("Profil")}
                    </button>
                    {dropdownOpen && (
                      <div className="absolute mt-2 right-0 bg-white border rounded-md shadow-lg z-10 w-32">
                        <button
                          onClick={() =>
                            navigate(`/${currentLanguage}/profile`)
                          }
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {t("Profil")}
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <a href={`/${currentLanguage}/login`}>
                    <img
                      alt="Login"
                      className="w-6 h-6"
                      src={aboveHeader2}
                    ></img>
                  </a>
                )}
              </div>
              <a href={`/${currentLanguage}/favourites`}>
                <img
                  alt="Favourites"
                  className="w-6 h-6"
                  src={aboveHeader3}
                ></img>
              </a>
              <a href={`/${currentLanguage}/cart`} className="relative">
  <img alt="Cart" className="w-6 h-6" src={aboveHeader4} />
  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
    {cartItems?.length}
  </span>
</a>

 
              <LanguageSwitcher />
            </div>
          </div>
        </div>

        <div className="flex md:hidden max-w-containerSm h-[80px] justify-between items-center relative mx-auto">
          <div className="flex gap-10">
            <div className="flex gap-3">
              <div className="relative inline-block text-left">
                {isLoggedIn ? (
                  <div>
                    <button
                      type="button"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      className="bg-[#181D27] text-white px-6 sm:px-7 md:px-8 py-2 rounded-full"
                    >
                      {isLoggedInUser || t("Profil")}
                    </button>

                    {dropdownOpen && (
                      <div className="absolute mt-2 right-0 bg-white border rounded-md shadow-lg z-10 w-32">
                        <button
                          onClick={() =>
                            navigate(`/${currentLanguage}/profile`)
                          }
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {t("Profil")}
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <a href={`/${currentLanguage}/login`}>
                    <img
                      alt="Login"
                      className="w-6 h-6"
                      src={aboveHeader2}
                    ></img>
                  </a>
                )}
              </div>
              <button
                className="md:hidden focus:outline-none"
                onClick={toggleHamburgerMenu}
              >
                <i className="fa-solid fa-bars text-[24px] text-[black]"></i>
              </button>
            </div>
          </div>
          <div className="flex items-center">
            <a href={`/${currentLanguage}`}>
              {" "}
              <img alt="Logo" className="w-[48px] h-[48px]" src={logo}></img>
            </a>
          </div>
          <div className="flex gap-10">
            <div className="flex gap-3">
              <a href={`/${currentLanguage}/cart`} className="relative">
  <img alt="Cart" className="w-6 h-6" src={aboveHeader4} />
  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
    3
  </span>
</a>

              <a href={`/${currentLanguage}/favourites`}>
                <img
                  alt="Favourites"
                  className="w-6 h-6"
                  src={aboveHeader3}
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Arama Sonuçları */}
      {searchQuery && (
        <div className="absolute top-0 left-0 w-full bg-white z-20 mt-[144px] hidden md:block">
          {isLoading2 ? (
            <p className="text-black text-center">Loading...</p>
          ) : (
            <PaginatedItems itemsPerPage={12} items={filteredProducts} />
          )}
        </div>
      )}
      {searchQuery && (
        <div className="absolute top-0 left-0 w-full bg-[white] mt-[170px] md:hidden z-50">
          {isLoading2 ? (
            <p className="text-black text-center">Loading...</p>
          ) : (
            <PaginatedItemsMobile itemsPerPage={12} items={filteredProducts} />
          )}
        </div>
      )}

      {isHamburgerMenuOpen && (
        <div
          className={`fixed inset-y-0 bg-[white] left-0 transform ${
            isHamburgerMenuOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out w-full z-40 shadow-lg`}
        >
          <div className="flex flex-col items-start max-w-containerSm mx-auto mt-4 w-full ">
            <div className="flex justify-between w-full">
              <a className="block" href={`/${currentLanguage}`}>
                {" "}
                <img src={logo} alt="Logo" className="w-[80px]" />
              </a>

              <button onClick={toggleHamburgerMenu}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="black"
                  width="24"
                  height="24"
                >
                  <path
                    d="M6 6L18 18M18 6L6 18"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="items-center justify-center h-screen w-full mt-4">
              <div className="gap-4 max-w-containerSm flex flex-col">
                <div className="relative mt-3">
                  <button className="absolute top-3 left-4 text-white">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75ZM1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5Z"
                        fill="black"
                      />
                    </svg>
                  </button>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder={t("Axtar...")}
                    className="rounded-[50px] w-full md:w-[755px] outline-none focus:ring-0 h-[44px] focus:outline-none border-[#C3C3C3] border-2 px-12 text-firstColork"
                  />
                  {/* <button onClick={toggleSearch} className="absolute top-3 right-20 text-white">
                <img className='w-4 h-4' src={close}></img>
              </button> */} 
                </div>
                <a
                  className={`text-base text-left mt-5 font-normal ${
                    isActiveLink(`/${currentLanguage}`)
                      ? "text-[#223077] "
                      : "text-[black]"
                  }`}
                  href={`/${currentLanguage}`}
                >
                  {" "}
                  {t("Ana səhifə")}
                </a>
                <a
                  href={`/${currentLanguage}/about`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/about`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Haqqımızda")}
                </a>
                <a
                  href={`/${currentLanguage}/products`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/products`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Məhsullar")}
                </a>
                <a
                  href={`/${currentLanguage}/kampaniya`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/kampaniya`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Kampaniyalar")}
                </a>
                <a
                  href={`/${currentLanguage}/blogs`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/blogs`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Bloq")}
                </a>
                <a
                  href={`/${currentLanguage}/comments`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/comments`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Müştəri Rəyləri")}
                </a>
                <a
                  href={`/${currentLanguage}/privacy`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/privacy`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Məxfilik")}
                </a>
                <a
                  href={`/${currentLanguage}/contact`}
                  className={`text-base text-left font-normal ${
                    isActiveLink(`/${currentLanguage}/contact`)
                      ? "text-[#223077]"
                      : "text-[black]"
                  }`}
                >
                  {t("Əlaqə")}
                </a>
                <div className="mt-5">
                  <LanguageSwitcher />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
